import React, { useEffect, useState, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import Map from "../../components/Map/ReflectionLocationDashboard";
import GenericCard from '../../components/Card/CardGenric';
import { serverUrl } from '../../components/Helpers/Config'
import { tokenAuthorize, analyticsView } from "../../components/Helpers/Common";
import { Pie, Doughnut, Bar } from "react-chartjs-2";
import { faker } from '@faker-js/faker';
import 'chart.js';
import InfoIcon from '@mui/icons-material/Info';
import { ActiveIconColor, BgComment, BgWhite, ButtonCommonTop, Card, MenuItemDiv } from "../Theme";
import { AiOutlineClose } from "react-icons/ai";
import CROSS_BLACK_ICON from '@mui/icons-material/Clear';
import 'chartjs-plugin-doughnutlabel';
import MarkDownContent from '../../pages/Journal/MarkDownContent';
import noDataAvailableImg from '../../common/images-new/no-data-available.png';
import Tooltip from '@mui/material/Tooltip';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { IconButton, Menu, MenuItem } from '@mui/material';

const chartOptionsReflectionWritten = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        position: 'top',
        display: false
    },
    scales: {
        yAxes: [
            {
                ticks: {
                    min: 0,
                    beginAtZero: true,
                    // Only show whole numbers
                    userCallback: function (value) {
                        if (Number.isInteger(value)) {
                            return value;
                        }
                        return '';
                    }
                }
            }
        ]
    }
};

function GenericAnalytics() {
    const dispatch = useDispatch()
    const [dashboardCard, setDashboardCard] = useState([]);
    const [reflectionByYear, setReflectionByYear] = useState({});
    const [reflectionYearsOptions, setReflectionYearsOptions] = useState([]);
    const [reflectionYearsValue, setReflectionYearsValue] = useState(null);
    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [taggedCourses, setTaggedCourses] = useState([]);
    const [taggedTopics, setTaggedTopics] = useState([]);
    const [taggedLocations, setTaggedLocations] = useState([]);
    const [artefacts, setArtefacts] = useState([]);
    const modalRef = useRef();
    const baseColors = [
        "#002B4D", // very dark navy
        "#004578", // dark blue
        "#005a9e", // strong blue
        "#0078d4", // primary blue
        "#2084D4", // bright azure
        "#3399FF", // soft vibrant blue
        "#71afe5", // muted light blue
        "#A8D1F2", // sky blue
        "#C7E0F4", // pale blue
        "#E5F1FB"  // very light blue
    ];
    //["#c7e0f4", "#71afe5", "#2084D4", "#0078d4", "#005a9e", "#004578"]
    const analyticsCardsDetails = useSelector((state) => state.analyticsReducer.card_details || []);

    const chartOptionsArtefacts = {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            position: 'nearest',
        },
        legend: {
            position: 'top',
            labels: {
                fontColor: '#9CA3AF',
                fontSize: 12
            },
        },
        plugins: {
            doughnutlabel: {
                labels: [
                    {
                        text: `${Object.values(dashboardCard?.artefacts || {}).reduce((sum, value) => sum + value, 0)}`,
                        font: {
                            size: 20,
                            weight: 'bold',
                        },
                    },
                    {
                        text: 'Artefacts',
                    },
                ],
            },
        },
    };
    useEffect(() => {
        axios.get(serverUrl.AnalyticsGenericCard).then(resp => {
            if (resp.status === 200) {
                setDashboardCard(resp?.data?.results);
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
        });
        // axios.get(serverUrl.AnalyticsGenericCharts).then(resp => {
        //     if (resp.status === 200) {
        //     }
        // }).catch(err => {
        //     tokenAuthorize(err?.response?.status);
        // });
        axios.get(serverUrl.AnalyticsGenericReflectionYearValueCharts).then(resp => {
            if (resp.status === 200) {
                setReflectionYearsOptions(resp?.data?.results);
                setReflectionYearsValue(resp?.data?.results[resp?.data?.results?.length - 1] || [new Date().getFullYear()])
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
        });
    }, []);
    useEffect(() => {
        if (reflectionYearsValue) {
            axios.get(serverUrl.AnalyticsGenericReflectionYearCharts + '?year=' + reflectionYearsValue).then(resp => {
                if (resp.status === 200) {
                    setReflectionByYear({
                        labels: resp?.data?.results.map(item => {
                            const monthMap = {
                                Jan: "January", Feb: "February", Mar: "March", Apr: "April",
                                May: "May", Jun: "June", Jul: "July", Aug: "August",
                                Sep: "September", Oct: "October", Nov: "November", Dec: "December"
                            };
                            return monthMap[item.month];
                        }),
                        datasets: [
                            {
                                label: "Reflections",
                                data: resp?.data?.results?.length === 12
                                    ? resp.data.results.map(item => item.total_reflection)
                                    : Array.from({ length: 12 }, () => faker.datatype.number({ min: 0, max: 10 })),
                                backgroundColor: "#2084D4"
                            }
                        ]
                    })
                }
            }).catch(err => {
                tokenAuthorize(err?.response?.status);
            })
        }
    }, [reflectionYearsValue]);

    // const chartOptionsTaggedCourses = {
    //     responsive: true,
    //     maintainAspectRatio: false,
    //     plugins: {
    //         legend: {
    //             position: "bottom",
    //         },
    //         tooltips: {
    //             callbacks: {
    //                 label: function (tooltipItem, data) {
    //                     const label = data.labels[tooltipItem.index] || '';
    //                     const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

    //                     // Split label at the first hyphen
    //                     const [code, ...rest] = label.split(/-(.+)/); // Match first hyphen
    //                     const name = (rest.length ? rest[0] : '').trim();
    //                     // Return single string with line break
    //                     return `${code.trim()} -\n${name}: ${value}`;
    //                 }
    //             }
    //         }
    //     },
    // };
    useEffect(() => {
        if (dashboardCard?.tagged_courses?.length > 0) {
            let labels = dashboardCard?.tagged_courses?.map(item => item?.course_title);
            let data = dashboardCard?.tagged_courses?.map(item => item?.tagged_count);
            let backgroundColor = dashboardCard?.tagged_courses.map((_, index) => baseColors[index % baseColors?.length]);
            setTaggedCourses({
                labels,
                datasets: [
                    {
                        label: "Tagged Courses",
                        data,
                        backgroundColor,
                        borderWidth: 1,
                    }
                ]
            });
        }
        else {
            setTaggedCourses({
                labels: [],
                datasets: [
                    {
                        label: "Tagged Courses",
                        data: [],
                        backgroundColor: ["#2084D4"],
                        borderWidth: 1,
                    }
                ]
            });
        }
        if (dashboardCard?.tagged_topics?.length > 0) {
            let labels = dashboardCard?.tagged_topics?.map(item => item?.event_title);
            let data = dashboardCard?.tagged_topics?.map(item => item?.tagged_count);
            let backgroundColor = dashboardCard?.tagged_topics.map((_, index) => baseColors[index % baseColors?.length]);
            setTaggedTopics({
                labels,
                datasets: [
                    {
                        label: "Tagged Topics",
                        data,
                        backgroundColor,
                        borderWidth: 1,
                    }
                ]
            });
        }
        else {
            setTaggedTopics({
                labels: [],
                datasets: [
                    {
                        label: "Tagged Topics",
                        data: [],
                        backgroundColor: ["#2084D4"],
                        borderWidth: 1,
                    }
                ]
            });
        }
        if (dashboardCard?.artefacts && Object.keys(dashboardCard?.artefacts).length > 0) {
            const labels = Object.keys(dashboardCard.artefacts).map(label =>
                label.charAt(0).toUpperCase() + label.slice(1)
            );
            const data = Object.values(dashboardCard.artefacts);
            const backgroundColor = labels.map((_, index) => baseColors[index % baseColors.length]);
            setArtefacts({
                labels,
                datasets: [
                    {
                        label: "Artefacts",
                        data,
                        backgroundColor,
                        borderWidth: 1,
                    }
                ]
            });
        }
        else {
            setArtefacts({
                labels: [],
                datasets: [
                    {
                        label: "Artefacts",
                        data: [],
                        backgroundColor: ["#2084D4"],
                        borderWidth: 1,
                    }
                ]
            });
        }
        setTaggedLocations(dashboardCard?.tagged_locations || []);

    }, [dashboardCard]);

    const splitEveryTwoWords = (text) => {
        const words = text?.split(" ");
        const lines = [];
        for (let i = 0; i < words.length; i += 2) {
            lines.push(words.slice(i, i + 2).join(" "));
        }
        return lines.join('\n'); // \n works for canvas in Chart.js v2
    };

    const Popup = () => {
        let style = show ? "flex" : "hidden";
        // style +=
        //     " fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block z-50";
        return (
            <div className={style} onClick={(e) => e.stopPropagation()}>
                <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
                    <div className={`relative ReflectinWritten rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 modal-popup-width`} id="cards">
                        <div className="flex gap-2 items-center justify-between">
                            <p className="font-semibold">Reflections Written</p>
                            <button
                                onClick={(e) => { setShow(!show) }}
                                className="text-gray-600 hover:text-black text-xl font-bold"
                            >&times;
                            </button>
                        </div>
                        <div className="overflow-y-auto h-96 scroll-smooth model-AnalyticeSection custom-scrollbarValuesandCompetencies" ref={modalRef}>
                            <div key={1} className="">
                                <p className="text-sm justify-center pt-3 text-justify pr-1.5">
                                    {analyticsCardsDetails?.filter(x => x.card_name == "ga_reflections_written")[0]?.is_html_content ?
                                        <MarkDownContent htmlContent={analyticsCardsDetails?.filter(x => x.card_name == "ga_reflections_written")[0]?.full_description} className={false} /> :
                                        analyticsCardsDetails?.filter(x => x.card_name == "ga_reflections_written")[0]?.full_description}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    return (
        <div className='w-full backGroundColor border20pxbottom pt-5 pb-5'>
            <Popup />
            <div className=''>
                <GenericCard data={dashboardCard} />
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-4 pb-4">
                {[1, 2, 3, 4].map((card, index) => (<>
                    <div key={index} className="flip-card h-100">
                        <div className="flip-card-inner border20px shadow-sm cardBackgroundColor">
                            {/* Front */}
                            <div className="flip-card-front">
                                {index === 0 && (
                                    <>
                                        <p className='blackColor text-xl font-semibold text-center'>Tagged Courses <Tooltip title={analyticsView} placement="top" arrow>
                                            <span><InfoIcon className='flip-trigger cursor-pointer primaryIcon' /></span>
                                        </Tooltip></p>
                                        {dashboardCard?.tagged_courses?.length === 0 ? <>
                                            <div className='m-auto justify-center'>
                                                <img src={noDataAvailableImg} alt="pics" className='overflow-hidden w-48' />
                                            </div>
                                        </> :
                                            (
                                                (() => {
                                                    const chartOptionsTaggedCourses = {
                                                        responsive: true,
                                                        maintainAspectRatio: false,
                                                        legend: {
                                                            display: true,
                                                            position: 'top',
                                                            labels: {
                                                                fontColor: '#9CA3AF',
                                                                fontSize: 12
                                                            }
                                                            //     generateLabels: function (chart) {
                                                            //         const data = chart.data;
                                                            //         const bgColors = data?.datasets[0]?.backgroundColor || [];

                                                            //         return data.labels.map((label, i) => {
                                                            //             const safeLabel = label || `Label ${i + 1}`;

                                                            //             // Safe split using regex to avoid breaking on missing dash
                                                            //             let courseCode = safeLabel;
                                                            //             let title = '';

                                                            //             if (safeLabel.includes('-')) {
                                                            //                 const [code, titleRaw] = safeLabel.split(/-(.+)/);
                                                            //                 courseCode = code?.trim();
                                                            //                 title = titleRaw?.trim() || '';
                                                            //             }

                                                            //             const words = title.split(' ');
                                                            //             const limitedTitle = words.slice(0, 3).join(' ') + (words.length > 3 ? '…' : '');
                                                            //             const finalText = title ? `${courseCode} - ${limitedTitle}` : courseCode;

                                                            //             return {
                                                            //                 text: finalText,
                                                            //                 fillStyle: bgColors[i] || '#ccc',
                                                            //                 strokeStyle: bgColors[i] || '#ccc',
                                                            //                 lineWidth: 1,
                                                            //                 hidden: chart.getDatasetMeta(0).data[i]?.hidden || false,
                                                            //                 index: i
                                                            //             };
                                                            //         });
                                                            //     },
                                                            //     fontColor: '#000',
                                                            //     fontSize: 12,
                                                            //     boxWidth: 20,
                                                            //     padding: 10
                                                            // }
                                                        },
                                                        tooltips: {
                                                            displayColors: true, // keep the color box
                                                            callbacks: {
                                                                label: function (tooltipItem, data) {
                                                                    const fullLabel = dashboardCard?.tagged_courses?.[tooltipItem.index]?.course_title || '';
                                                                    const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                                                                    const [code, ...rest] = fullLabel.split(/-(.+)/); // split on first hyphen
                                                                    const courseCode = code.trim();
                                                                    const title = rest.length ? rest[0].trim() : '';
                                                                    const words = title.split(' ');

                                                                    // Short = everything in one line
                                                                    if (words.length <= 4) {
                                                                        return `${courseCode} ${title}: ${value}`;
                                                                    }

                                                                    // Long = only code in label (color box line)
                                                                    return courseCode;
                                                                },
                                                                afterLabel: function (tooltipItem, data) {
                                                                    const fullLabel = dashboardCard?.tagged_courses?.[tooltipItem.index]?.course_title || '';
                                                                    const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                                                                    const [_, ...rest] = fullLabel.split(/-(.+)/);
                                                                    const title = rest.length ? rest[0].trim() : '';
                                                                    const words = title.split(' ');

                                                                    // Short = skip afterLabel
                                                                    if (words.length <= 4) return;

                                                                    // Wrap title and append value to last line
                                                                    const lines = [];
                                                                    for (let i = 0; i < words.length; i += 4) {
                                                                        const isLast = i + 4 >= words.length;
                                                                        const line = words.slice(i, i + 4).join(' ');
                                                                        lines.push(isLast ? `${line}: ${value}` : line);
                                                                    }

                                                                    return lines;
                                                                },
                                                                footer: () => null
                                                            }
                                                        }

                                                    };

                                                    return (
                                                        <div className='chart-content'>
                                                            <Doughnut data={taggedCourses} options={chartOptionsTaggedCourses} />
                                                        </div>
                                                    );
                                                })()
                                            )
                                        }
                                        <p className={`text-sm lightColor text-center ${dashboardCard?.tagged_courses?.length == 0 ? "" : "mt-auto"}`}>{analyticsCardsDetails?.filter(x => x.card_name == "ga_tagged_courses")[0]?.simple_description}</p>
                                    </>
                                )}
                                {index === 1 && (
                                    <>
                                        <p className='blackColor text-xl font-semibold text-center'>Tagged Topics <Tooltip title={analyticsView} placement="top" arrow>
                                            <span><InfoIcon className='flip-trigger cursor-pointer primaryIcon' /></span>
                                        </Tooltip></p>
                                        {dashboardCard?.tagged_topics?.length === 0 ? <>
                                            <div className='m-auto justify-center'>
                                                <img src={noDataAvailableImg} alt="pics" className='overflow-hidden w-48' />
                                            </div></> : (
                                            (() => {
                                                const chartOptionsTaggedTopics = {
                                                    responsive: true,
                                                    maintainAspectRatio: false,
                                                    legend: {
                                                        position: "top",
                                                        labels: {
                                                            fontColor: '#9CA3AF',
                                                            fontSize: 12
                                                        }
                                                        // labels: {
                                                        //     generateLabels: function (chart) {
                                                        //         const data = chart.data;
                                                        //         return data.labels.map((label, i) => ({
                                                        //             text: label,
                                                        //             fillStyle: data.datasets[0].backgroundColor[i],
                                                        //             hidden: false,
                                                        //             index: i
                                                        //         }));
                                                        //     },
                                                        //     // fontSize: 10
                                                        // }
                                                    },
                                                    tooltips: {
                                                        displayColors: true, // keep the color box
                                                        callbacks: {
                                                            label: function (tooltipItem, data) {
                                                                const fullLabel = dashboardCard?.tagged_topics?.[tooltipItem.index]?.event_title || '';
                                                                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                                                                const [code, ...rest] = fullLabel.split(/-(.+)/); // split on first hyphen
                                                                const courseCode = code.trim();
                                                                const title = rest.length ? rest[0].trim() : '';
                                                                const words = title.split(' ');

                                                                // Short = everything in one line
                                                                if (words.length <= 4) {
                                                                    return `${courseCode} ${title}: ${value}`;
                                                                }

                                                                // Long = only code in label (color box line)
                                                                return courseCode;
                                                            },
                                                            afterLabel: function (tooltipItem, data) {
                                                                const fullLabel = dashboardCard?.tagged_topics?.[tooltipItem.index]?.event_title || '';
                                                                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                                                                const [_, ...rest] = fullLabel.split(/-(.+)/);
                                                                const title = rest.length ? rest[0].trim() : '';
                                                                const words = title.split(' ');

                                                                // Short = skip afterLabel
                                                                if (words.length <= 4) return;

                                                                // Wrap title and append value to last line
                                                                const lines = [];
                                                                for (let i = 0; i < words.length; i += 4) {
                                                                    const isLast = i + 4 >= words.length;
                                                                    const line = words.slice(i, i + 4).join(' ');
                                                                    lines.push(isLast ? `${line}: ${value}` : line);
                                                                }

                                                                return lines;
                                                            },
                                                            footer: () => null
                                                        }
                                                    }

                                                };

                                                return (
                                                    <div className='chart-content'>
                                                        <Pie data={taggedTopics} options={chartOptionsTaggedTopics} />
                                                    </div>
                                                );
                                            })()
                                        )
                                        }
                                        <p className={`text-sm lightColor text-center ${dashboardCard?.tagged_topics?.length === 0 ? "" : "mt-auto"}`}>{analyticsCardsDetails?.filter(x => x.card_name == "ga_tagged_topics")[0]?.simple_description}</p>
                                    </>
                                )}
                                {index === 2 && (
                                    <>
                                        <p className="blackColor text-xl font-semibold text-center">
                                            Artefacts Diversity <Tooltip title={analyticsView} placement="top" arrow>
                                                <span><InfoIcon className='flip-trigger cursor-pointer primaryIcon' /></span>
                                            </Tooltip>
                                        </p>

                                        {Object.keys(dashboardCard?.artefacts || {}).length === 0 ? (
                                            <div className="m-auto justify-center">
                                                <img src={noDataAvailableImg} alt="No data available" className="w-48" />
                                            </div>
                                        ) :
                                            <div className="chart-content">
                                                <Doughnut data={artefacts} options={chartOptionsArtefacts} />
                                            </div>
                                        }

                                        <p className={`text-sm lightColor text-center ${Object.keys(dashboardCard?.artefacts || {}).length === 0 ? "" : "mt-auto"}`}>
                                            {
                                                analyticsCardsDetails?.find(x => x.card_name === "ga_artefacts_diversity")
                                                    ?.simple_description
                                            }
                                        </p>
                                    </>
                                )}

                                {index === 3 && (
                                    <>
                                        <p className='blackColor text-xl font-semibold text-center'>Tagged Locations <Tooltip title={analyticsView} placement="top" arrow>
                                            <span><InfoIcon className='flip-trigger cursor-pointer primaryIcon' /></span>
                                        </Tooltip></p>
                                        <div className='text-center'>
                                            <p className="DPStatisticsCount font-bold text-center blueColor">{taggedLocations?.length}</p>
                                            <p className="text-lg font-medium text-center lightColor mb-2">Reflection(s) with Locations</p>
                                        </div>
                                        <div className="md:block flex flex-col lg:mt-5 mb-5">
                                            <Map data={taggedLocations} />
                                        </div>
                                        <p className="text-sm lightColor mt-auto text-center">{analyticsCardsDetails?.filter(x => x.card_name == "ga_tagged_locations")[0]?.simple_description}</p>
                                    </>
                                )}
                            </div>
                            {/* Back */}
                            <div className="flip-card-back bg-opacity-80">
                                {index === 0 && (<>
                                    <div className=''>
                                        <button
                                            className="cursor-pointer hover:opacity-60 float-right flip-triggerClosed text-xl font-bold"
                                        >&times;
                                        </button>
                                        <h3 className="text-xl font-semibold mb-2">Tagged Courses</h3>
                                    </div>
                                    <div className="overflow-y-auto custom-scrollbar">
                                        <p className="text-sm text-justify pt-3 px-5">
                                            {analyticsCardsDetails?.filter(x => x.card_name == "ga_tagged_courses")[0]?.is_html_content ?
                                                <MarkDownContent htmlContent={analyticsCardsDetails?.filter(x => x.card_name == "ga_tagged_courses")[0]?.full_description} className={false} /> :
                                                analyticsCardsDetails?.filter(x => x.card_name == "ga_tagged_courses")[0]?.full_description}
                                        </p>
                                    </div>
                                </>)}
                                {index === 1 && (<>
                                    <div className=''>
                                        <button
                                            className="cursor-pointer hover:opacity-60 float-right flip-triggerClosed text-xl font-bold"
                                        >&times;
                                        </button>
                                        <h3 className="text-xl font-semibold mb-2">Tagged Topics</h3>
                                    </div>
                                    <div className="overflow-y-auto custom-scrollbar">
                                        <p className="text-sm text-justify pt-3 px-5">
                                            {analyticsCardsDetails?.filter(x => x.card_name == "ga_tagged_topics")[0]?.is_html_content ?
                                                <MarkDownContent htmlContent={analyticsCardsDetails?.filter(x => x.card_name == "ga_tagged_topics")[0]?.full_description} className={false} /> :
                                                analyticsCardsDetails?.filter(x => x.card_name == "ga_tagged_topics")[0]?.full_description}
                                        </p>
                                    </div>
                                </>)}
                                {index === 2 && (<>
                                    <div className=''>
                                        <button
                                            className="cursor-pointer hover:opacity-60 float-right flip-triggerClosed text-xl font-bold"
                                        >&times;
                                        </button>
                                        <h3 className="text-xl font-semibold mb-2">Artefacts Diversity</h3>
                                    </div>
                                    <div className="overflow-y-auto custom-scrollbar">
                                        <p className="text-sm text-justify pt-3 px-5">
                                            {analyticsCardsDetails?.filter(x => x.card_name == "ga_artefacts_diversity")[0]?.is_html_content ?
                                                <MarkDownContent htmlContent={analyticsCardsDetails?.filter(x => x.card_name == "ga_artefacts_diversity")[0]?.full_description} className={false} /> :
                                                analyticsCardsDetails?.filter(x => x.card_name == "ga_artefacts_diversity")[0]?.full_description}
                                        </p>
                                    </div>
                                </>)}
                                {index === 3 && (<>
                                    <div className=''>
                                        <button
                                            className="cursor-pointer hover:opacity-60 float-right flip-triggerClosed text-xl font-bold"
                                        >&times;
                                        </button>
                                        <h3 className="text-xl font-semibold mb-2">Tagged Locations</h3>
                                    </div>
                                    <div className="overflow-y-auto custom-scrollbar">
                                        <p className="text-sm text-justify pt-3 px-5">
                                            {analyticsCardsDetails?.filter(x => x.card_name == "ga_tagged_locations")[0]?.is_html_content ?
                                                <MarkDownContent htmlContent={analyticsCardsDetails?.filter(x => x.card_name == "ga_tagged_locations")[0]?.full_description} className={false} /> :
                                                analyticsCardsDetails?.filter(x => x.card_name == "ga_tagged_locations")[0]?.full_description}
                                        </p>
                                    </div>
                                </>)}
                            </div>
                        </div>
                    </div>
                </>))}
            </div>
            <div className="grid grid-cols-12 gap-4">
                <div className="border20px shadow-sm cardBackgroundColor col-span-12 p-4">
                    <div className='flex flex-wrap justify-between'>
                        <p className="blackColor text-xl font-semibold mb-4">
                            Reflections Written <Tooltip title={analyticsView} placement="top" arrow>
                                <span><InfoIcon className='flip-trigger cursor-pointer primaryIcon' onClick={(e) => { setShow(!show) }} /></span>
                            </Tooltip>
                        </p>
                        <div className='flex gap-3 items-center'>
                            <label htmlFor="yearSelect" className="text-gray-700">
                                Year:
                            </label>
                            {/* <select
                                id="yearSelect"
                                className="px-2 py-1 border-2 border-gray-300 rounded focus:outline-none"
                                defaultValue=""
                                onChange={(e) => setReflectionYearsValue(e.target.value)}
                                value={reflectionYearsValue}
                            >
                                {reflectionYearsOptions.map((option, idx) => (
                                    <option key={idx} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select> */}
                            <FormControl className="w-full rounded-full-tab h-7">
                                <Select
                                    value={reflectionYearsValue || ""}
                                    onChange={(e) => setReflectionYearsValue(e.target.value)}
                                    displayEmpty
                                    size="small"
                                    fullWidth
                                    className='h-7'
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    sx={
                                        {
                                            '& .MuiSelect-select': {
                                                padding: '0px 25px 3px 8px !important',
                                            },
                                            '& .MuiSvgIcon-root': {
                                                right: '0px !important',
                                            }
                                        }
                                    }
                                    MenuProps={{
                                        disableScrollLock: true,
                                    }}
                                >
                                    {reflectionYearsOptions.map((option, idx) => (
                                        <MenuItem key={idx} className="DropDownFont" value={option}>
                                            <MenuItemDiv className="blackColor">
                                                {option}
                                            </MenuItemDiv>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className='barchart-content'>
                        <Bar data={reflectionByYear} options={chartOptionsReflectionWritten} />
                    </div>
                    <p className="text-sm lightColor mt-auto text-center">{analyticsCardsDetails?.filter(x => x.card_name == "ga_reflections_written")[0]?.simple_description}</p>
                </div>
                {/* <div className="bg-white p-4 rounded shadow col-span-12 md:col-span-6 lg:col-span-3">
                    <p className="blackColor text-xl font-semibold mb-4">
                        Shared Reflection
                    </p>
                    <Bar data={barShardedData} options={chartOptionsReflectionWritten} height={300} />
                </div> */}
            </div>
        </div >
    )
}

export default GenericAnalytics
